<template>
  <section class="max-w-lg mx-auto">
    <div
      v-if="form.errors.has('message')"
      class="card text-center bg-red text-white mx-auto p-4 mb-6"
      v-text="form.errors.get('message')"
    />
    <div class="w-full">
      <fieldset>
        <legend
          class="fieldset-legend"
          v-text="'Post Preview'"
        />
        <h3 v-text="'Title'" />
        <div
          v-if="form.title"
          class="hover:bg-grey-light cursor-pointer mb-6 p-4 border border-grey rounded italic"
          @click.prevent="$emit('changeActiveTab', 'discuss')"
          v-text="form.title"
        />
        <div
          v-else
          class="hover:bg-grey-light cursor-pointer mb-6 p-4 border border-red rounded italic text-red"
          @click.prevent="$emit('changeActiveTab', 'discuss')"
          v-text="'No post title provided!'"
        />
        <h3 v-text="'Category'" />
        <div
          v-if="form.category.uuid"
          class="hover:bg-grey-light cursor-pointer mb-6 p-4 border border-grey rounded italic"
          @click="$emit('changeActiveTab', 'discuss')"
          v-text="selectedCategoryTitle"
        />
        <h3
          v-else
          class="hover:bg-grey-light cursor-pointer mb-6 p-4 border border-red rounded italic text-red"
          @click="$emit('changeActiveTab', 'discuss')"
          v-text="'No post category selected!'"
        />
        <h3 v-text="'Content'" />
        <div
          v-if="form.body"
          class="hover:bg-grey-light overflow-scroll cursor-pointer mb-6 px-4 border border-grey rounded"
          style="max-height: 24em"
          @click="$emit('changeActiveTab', 'discuss')"
          v-html="form.body"
        />
        <h3
          v-else
          class="hover:bg-grey-light cursor-pointer mb-6 p-4 border border-red rounded italic text-red"
          @click="$emit('changeActiveTab', 'discuss')"
          v-text="'No post content provided!'"
        />
        <h3 v-text="'Documents'" />
        <div
          v-if="form.filesInQueue || form.documentsToRemove.length"
          class="hover:bg-grey-light overflow-scroll cursor-pointer mb-6 p-4 border border-grey rounded"
          style="max-height: 24em"
          @click="$emit('changeActiveTab', 'documents')"
        >
          <ul class="my-0 list-reset">
            <li v-if="form.filesInQueue">
              File(s) to add: <span v-text="form.filesInQueue" />
            </li>
            <li
              v-if="form.documentsToRemove.length"
              class="text-red"
              v-text="`File(s) to remove: ${form.documentsToRemove.length}`"
            />
          </ul>
        </div>
        <div
          v-else
          class="hover:bg-grey-light cursor-pointer mb-6 p-4 border border-grey rounded italic"
          @click="$emit('changeActiveTab', 'documents')"
          v-text="'No files attached.'"
        />
      </fieldset>
    </div>
    <div class="mt-6 text-center">
      <button
        type="button"
        class="btn"
        :class="{ 'load': form.busy }"
        :disabled="!readyForPublishing || form.busy"
        :aria-disabled="!readyForPublishing || form.busy"
        @click="$emit('send')"
        v-text="buttonText"
      />
    </div>
  </section>
</template>

<script type="text/babel">
export default {
  name: 'PreviewPane',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(form) {
        this.$emit('input', form)
      },
    },
    readyForPublishing() {
      return this.form.title && this.form.category.uuid && this.form.body
    },
    selectedCategoryTitle() {
      return _.get(_.find(this.$store.state.discussion.categories.data, { uuid: this.form.category.uuid }),
        'attributes.title', '')
    },
    buttonText() {
      if (this.form.uploadingDocuments) {
        return `Uploading documents... (${this.form.currentUploadCount} of ${this.form.totalUploadCount})`
      }

      if (this.form.busy) {
        return this.form.exists ? 'Updating discussion...' : 'Posting new discussion...'
      }

      return this.form.exists ? 'Update discussion' : 'Post new discussion'
    },
  },
}
</script>
